import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 获取全部待办
  async getAllToDoList(params) {
    return request({
      method: POST,
      url: '/admin/approval/allToDoList',
      params: {
        ...params,
      },
    })
  },

  // 获取我的待办
  async getMyToDoList(params) {
    return request({
      method: POST,
      url: '/admin/approval/myToDoList',
      params: {
        ...params,
      },
    })
  },
}
